export default __webpack_public_path__ + "static/media/logo_planet_nom.17e06d7a.svg";